<template>
  <v-container>
    <v-row>
      <v-col cols="8" class="d-grid ma-0 pa-0 ">
        <v-row class="d-flex justify-between ">
          <v-col cols="5" class="px-1">
            <v-text-field v-model="key" label="Key" dense hide-details outlined></v-text-field>
          </v-col>
          <v-col cols="6" class="px-1">
            <v-text-field v-model="description" label="Description" dense hide-details outlined></v-text-field>
          </v-col>
          <v-col cols="1" class="px-1">
            <v-btn color="primary" @click="addKeys(key, description)">Add</v-btn>
          </v-col>
        </v-row>
        <v-row class="d-flex justify-end pe-0 ps-2">
          <v-col cols="7" class="pa-0">
            <v-text-field v-model="search" clearable dense hide-details label="Search" outlined
              prepend-inner-icon="mdi-magnify"></v-text-field>
          </v-col>
        </v-row>
        <v-row class="w-100">
          <v-data-table :headers="headers" :items="items" :search="search" class="elevation-1 mt-4"
            style="width: 100%;">
            <template v-slot:item.key="{ item }">
              <p class="text-start">{{ item.key }}</p>
              <p class="text-start"> {{ item.description }}</p>
            </template>
            <template v-slot:item.actions="{ item }">
              <td>
                <v-btn icon @click="deleteKey(item)"> <v-icon>mdi-delete</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script lang="js">
import { apiService } from '../../service/api.service'
import swal from 'sweetalert2'

export default {
  data: () => ({
    headers: [
      { text: 'Key', value: 'key' },
      { text: 'Description', value: 'description' },
      { text: 'Actions', value: 'actions', sortable: false, class: 'text-center', width: '9vh' }
    ],
    search: '',
    items: [],
    key: '',
    description: ''

  }),
  methods: {
    async getKeys () {
      const response = await apiService.get('default-keys')
      this.items = response.data.keys
    },
    async deleteKey (key) {
      if (key) {
        swal.fire({
          title: 'Are you sure?',
          text: 'You will not be able to recover this key!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, keep it',
          didOpen: (swalPopup) => {
            const buttons = swalPopup.querySelectorAll('.swal2-confirm, .swal2-cancel, .swal2-deny')
            buttons.forEach((button) => {
              button.style.color = 'white'
            })
          }
        }).then(async (result) => {
          if (result.isConfirmed) {
            apiService.delete('default-keys?id=' + key.id).then((resp) => {
              swal.fire({
                title: 'Success',
                text: 'Key deleted successfully',
                icon: 'success',
                confirmButtonText: 'OK',
                didOpen: (swalPopup) => {
                  const buttons = swalPopup.querySelectorAll('.swal2-confirm')
                  buttons.forEach((button) => {
                    button.style.color = 'white'
                  })
                }
              })
              this.getKeys()
            })
          }
        })
      }
    },
    async addKeys (key, description) {
      if (key !== '') {
        apiService.post('default-keys', { key: key, description: description }).then((resp) => {
          swal.fire({
            title: 'Success',
            text: 'Key added successfully',
            icon: 'success',
            confirmButtonText: 'OK',
            didOpen: (swalPopup) => {
              const buttons = swalPopup.querySelectorAll('.swal2-confirm')
              buttons.forEach((button) => {
                button.style.color = 'white'
              })
            }
          })
          this.getKeys()
          this.key = ''
          this.description = ''
        })
      } else {
        swal.fire({
          title: 'Error',
          text: 'Key cannot be empty',
          icon: 'error',
          confirmButtonText: 'OK',
          didOpen: (swalPopup) => {
            const buttons = swalPopup.querySelectorAll('.swal2-confirm')
            buttons.forEach((button) => {
              button.style.color = 'white'
            })
          }
        })
      }
    }
  },
  mounted () {
    this.getKeys()
  }
}
</script>
